import ApiConstants from "../../constants/ApiConstants";
import Utility from "../../utility/Utility";
import http from "../../http";


class TaxService {
    static getTaxDetail(countryCode) {
        const url = ApiConstants.URL.PEOPLE.TENANT+`/${countryCode}/tax`;
        return http
            .get(
                `${url}`
            )
            .catch((err: any) => {
                console.error('Error loading tax details: ', err);
                return Promise.reject(err);
            });
    }
    static saveTaxDetail(countryCode, param) {
        if (param && param.id) {
            const url = ApiConstants.URL.PEOPLE.TENANT + `/${countryCode}/tax`;
            return http
                .put(
                    `${url}`,
                    param
                )
                .catch((err: any) => {
                    console.error('Error update tax details: ', err);
                    return Promise.reject(err);
                });
        } else {
            const url = ApiConstants.URL.PEOPLE.TENANT + `/${countryCode}/tax`;
            return http
                .post(
                    `${url}`,
                    param
                )
                .catch((err: any) => {
                    console.error('Error saving tax details: ', err);
                    return Promise.reject(err);
                });
        }
    }

    static fetchUserTaxDetails(body) {
        const url = ApiConstants.URL.USER_TAX_DETAILS.FETCH;
        return http.post(
            `${url}`,
            body
        )
        .catch((err: any) => {
            console.error('Error fetching user tax details: ', err);
            return Promise.reject(err);
        });
    }

    static postUserTaxDetails(body) {
        const url = ApiConstants.URL.USER_TAX_DETAILS.POST;
        return http.post(
            `${url}`,
            body
        )
        .catch((err: any) => {
            console.error('Error fetching user tax details: ', err);
            return Promise.reject(err);
        });
    }

    static updatetUserTaxDetails(body) {
        const url = ApiConstants.URL.USER_TAX_DETAILS.PUT;
        return http.put(
            `${url}`,
            body
        )
        .catch((err: any) => {
            console.error('Error fetching user tax details: ', err);
            return Promise.reject(err);
        });
    }
}

export default TaxService;
